export default {
    delete_note_title: "Borrar la nota",
    delete_note_success_message: "La nota ha sido borrado",
    delete_note_label: "¿Estás seguro de que quieres borrar la nota?",
    delete_note_warning: "Esta acción no se puede deshacer. Esto eliminará permanentemente los datos y sus asociaciones.",
}